import React from "react";
import { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Autocomplete,
  TextField,
  Skeleton,
} from "@mui/material";
import { Close, Search } from "@mui/icons-material";
import Paper from "../../../../componentsv2/Paper";
import Button from "../../../../componentsv2/Button";
import Tabela from "../../../../componentsv2/Tabela";
import ModalConfirmaLote from "./ModalConfirmaLote";
import { api } from "../../../../services/Api";
import { useSnackbar } from "notistack";
import { validarCompetencia } from "../utils/lote";
import {
  filtrarConvenios,
  obterLabelConvenio,
  obterNomeConvenio,
} from "../../convenio";

const MESES_VALIDOS = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

const formatarMoeda = (valor) => {
  const numero = Number(valor);
  const valorSeguro = Number.isFinite(numero) ? numero : 0;

  return valorSeguro.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const ModalAdicionarLote = ({ open, handleClose, listaConvenios = [] }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [modalAdicionaLote, setAdicionaLote] = useState(false);

  const [loadingSoftlab, setLoadingSoftlab] = useState(false);

  const [convenio, setConvenio] = useState("");

  const [valorSoftlab, setValorSoftlab] = useState(null);

  const [mesCompetencia, setMesCompetencia] = useState("");
  const [anoCompetencia, setAnoCompetencia] = useState("");

  const [dataInicial] = useState(() => {
    const valueDateI = new Date();
    valueDateI.setDate(valueDateI.getDate() - 10);
    return valueDateI;
  });

  const [dataFinal] = useState(new Date());

  const [lote, setLote] = useState("");

  const [lotes, setLotes] = useState([]);

  const [valorLoteado, setValorLoteado] = useState(0);

  const [valorALotear, setValorALotear] = useState(null);
  const [valorDoLote, setValorDoLote] = useState("");

  const convenioSelecionado =
    listaConvenios.find((item) => item.convenio === convenio) || null;

  const getTotalSoftlab = async () => {
    if (!convenio) {
      enqueueSnackbar("Selecione um convênio.", {
        variant: "warning",
      });
      return;
    }

    const mensagemCompetencia = validarCompetencia(
      mesCompetencia + "/" + anoCompetencia,
    );

    if (mensagemCompetencia) {
      enqueueSnackbar(mensagemCompetencia, {
        variant: "warning",
      });
      return;
    }

    // let inicio = `${formatDateBD(dataInicial)} 00:00:00`;
    // let final = `${formatDateBD(dataFinal)} 23:59:59`;

    let valorLoteadoSum = 0;
    let valorSoftlabSum = 0;

    setLoadingSoftlab(true);

    try {
      const { data } = await api.get("/v2/faturamento/lotesPorPlano", {
        params: {
          // data_inicial: inicio,
          // data_final: final,
          competencia: `${mesCompetencia}/${anoCompetencia}`,
          plano: convenio,
        },
      });

      valorLoteadoSum = data?.reduce(
        (soma2, atual2) => soma2 + atual2.valor,
        0
      );

      setValorLoteado(valorLoteadoSum);
      setLotes(data);
    } catch (error) {
      console.log(error);
    }

    try {
      const { data: results } = await api.get(
        `/api/BuscaPorPedidos/geradoSoftlab`,
        {
          params: {
            // data_inicial: dataInicial,
            // data_final: dataFinal,
            competencia: `${mesCompetencia}/${anoCompetencia}`,
          },
        }
      );

      if (convenio !== null) {
        let filtrado = [];

        filtrado = results?.filter((item) => convenio === item.cod_guia.trim());

        valorSoftlabSum = filtrado.reduce(
          (soma, atual) => soma + atual.faturamento,
          0
        );

        setValorSoftlab(valorSoftlabSum);
      } else {
        valorSoftlabSum = results?.reduce(
          (soma, atual) => soma + atual.faturamento,
          0
        );

        setValorSoftlab(valorSoftlabSum);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingSoftlab(false);
    }

    setValorALotear(valorSoftlabSum - valorLoteadoSum);
  };

  const ultimoLote = async () => {
    try {
      const loteUnico = await api.get("/v2/faturamento/ultimoLote", {
        params: {
          plano: convenio,
        },
      });
      setLote(loteUnico.data);
      return loteUnico.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const handleOpenAdicionaModal = async () => {
    if (!convenio) {
      enqueueSnackbar("Selecione um convênio.", {
        variant: "warning",
      });
      return;
    }

    const mensagemCompetencia = validarCompetencia(
      mesCompetencia + "/" + anoCompetencia,
    );

    if (mensagemCompetencia) {
      enqueueSnackbar(mensagemCompetencia, {
        variant: "warning",
      });
      return;
    }

    const proximoLote = await ultimoLote();

    if (!proximoLote) {
      enqueueSnackbar("Não foi possível obter o próximo lote.", {
        variant: "error",
      });
      return;
    }

    setValorDoLote("");
    setAdicionaLote(true);
  };

  const handleCloseAdicionaModal = () => setAdicionaLote(false);

  // useEffect(() => {
  //   setValorALotear(valorSoftlab);
  // }, [valorSoftlab]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
    },
    {
      field: "codigo",
      headerName: "Cod. Lote",
      flex: 1,
    },
    {
      field: "competencia",
      headerName: "Competência",
      flex: 1,
    },
    {
      field: "plano",
      headerName: "Convênio",
      flex: 1,
      valueGetter: ({ row }) =>
        obterNomeConvenio({
          convenio: row.plano,
          nome_convenio: row.nome_convenio,
        }),
    },
    {
      field: "data_envio_lote",
      headerName: "Data do envio",
      flex: 1,
      valueFormatter: ({ value }) => new Date(value)?.toLocaleDateString(),
    },
    {
      field: "valor",
      headerName: "Valor Loteado",
      type: "number",
      flex: 1,
      valueFormatter: ({ value }) =>
        value?.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
    },
  ];

  useEffect(() => {
    setValorSoftlab(null);
    setValorLoteado(0);
    setValorALotear(null);
  }, [convenio, mesCompetencia, anoCompetencia, dataInicial, dataFinal]);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={handleClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        sx={{ justifyContent: "space-between" }}
      >
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h6">Adicionar Lote</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={() => handleClose(false)}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: "24px" }}>
        <Grid container spacing={2} direction="column">
          <Grid item>
            <Grid container spacing={2} alignItems="stretch">
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  options={listaConvenios}
                  value={convenioSelecionado}
                  getOptionLabel={obterLabelConvenio}
                  filterOptions={filtrarConvenios}
                  isOptionEqualToValue={(option, value) =>
                    option?.convenio === value?.convenio
                  }
                  onChange={(_event, value) => {
                    setConvenio(value?.convenio || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Convênio"
                      variant="outlined"
                      size="small"
                      required
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6} sm={3}>
                <Autocomplete
                  options={MESES_VALIDOS}
                  value={mesCompetencia}
                  onChange={(event, value) => {
                    if (value !== null && !MESES_VALIDOS.includes(value)) {
                      enqueueSnackbar("Mês inválido", {
                        variant: "warning",
                      });
                      return;
                    }

                    setMesCompetencia(value);
                  }}
                  disableClearable={mesCompetencia !== ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Mês"
                      variant="outlined"
                      size="small"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  id="anoCompetencia"
                  label="Ano"
                  placeholder="AAAA"
                  value={anoCompetencia}
                  onChange={(e) => setAnoCompetencia(e.target.value)}
                  inputProps={{ maxLength: 4, inputMode: "numeric" }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    getTotalSoftlab();
                  }}
                  startIcon={<Search />}
                  fullWidth
                  sx={{
                    height: "100%",
                    minHeight: "40px",
                    backgroundColor: "#003399",
                    "&:hover": {
                      backgroundColor: "#002266",
                    },
                  }}
                >
                  Buscar
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    p: 2,
                    textAlign: "center",
                  }}
                >
                  <>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      Total Gerado Softlab
                    </Typography>
                    {loadingSoftlab ? (
                      <Skeleton
                        variant="text"
                        width="80%"
                        height={32}
                        sx={{ margin: "0 auto" }}
                      />
                    ) : (
                      <Typography
                        variant="h6"
                        color="primary"
                        fontWeight="bold"
                      >
                        {formatarMoeda(valorSoftlab)}
                      </Typography>
                    )}
                  </>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    p: 2,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Total Loteado
                  </Typography>
                  <Typography
                    variant="h6"
                    color="success.main"
                    fontWeight="bold"
                  >
                    {formatarMoeda(valorLoteado)}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Paper
                  sx={{
                    p: 2,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Total a Lotear
                  </Typography>
                  {loadingSoftlab ? (
                    <Skeleton
                      variant="text"
                      width="80%"
                      height={32}
                      sx={{ margin: "0 auto" }}
                    />
                  ) : (
                    <Typography
                      variant="h6"
                      color="warning.main"
                      fontWeight="bold"
                    >
                      {formatarMoeda(valorALotear)}
                    </Typography>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <Tabela
              disableColumnMenu
              autoHeight
              columns={columns}
              rows={lotes}
              pageSize={5}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    id: false,
                  },
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "20px 24px",
          backgroundColor: "#f8f9fa",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Grid container justifyContent="flex-end" spacing={2}>
          <Grid item>
            <Button
              color="gray"
              variant="outlined"
              onClick={() => handleClose(false)}
              sx={{ minWidth: "120px" }}
            >
              Cancelar
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="green"
              onClick={handleOpenAdicionaModal}
              sx={{ minWidth: "120px" }}
            >
              Adicionar Lote
            </Button>
          </Grid>
        </Grid>
      </DialogActions>

      <ModalConfirmaLote
        open={modalAdicionaLote}
        handleClose={handleCloseAdicionaModal}
        convenio={convenio}
        nomeConvenio={convenioSelecionado?.nome_convenio}
        dataInicial={dataInicial}
        dataFinal={dataFinal}
        valorSoftlab={valorALotear}
        lote={lote}
        getTotalSoftlab={getTotalSoftlab}
        valorDoLote={valorDoLote}
        setValorDoLote={setValorDoLote}
        mesCompetencia={mesCompetencia}
        anoCompetencia={anoCompetencia}
      />
    </Dialog>
  );
};

export default ModalAdicionarLote;
